import { Box, Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { Link, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import AuthLayout from '../layouts/AuthLayout/AuthLayout';
import { useTheme } from '@mui/material';
import { useState } from 'react';
import { useAuthContext, AuthData } from '../contexts/AuthContext';


function ActivateAccount(props: any) {
  const theme= useTheme();
  const auth = useAuthContext();
  const navigate = useNavigate();

  const location = useLocation();

  const [ error, setError ] = useState<string | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const emailToVerify = searchParams.get("email"); // We'll need to configure a link in the email to include this query param

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const username = location?.state?.username ?? emailToVerify;
    const session = location?.state?.session;
    const password = location?.state?.password;
    const form = event.currentTarget;

    const formData = new FormData(form);
    const verificationCode = formData.get("verificationCode") as string;

    if(!verificationCode) {
      setError("Please enter a verification code");
      return;
    }

    auth.verify(username, verificationCode, session, (result: any) => {
      if (result.success) {
        auth.signinAfterVerify(username, password, result.data.Session, (result: any) => {
          if (result.success) {
            const authResults = result.data.AuthenticationResult;
            const data: AuthData = {
              access_token: authResults.AccessToken,
              id_token: authResults.IdToken,
              refresh_token: authResults.RefreshToken,
              expires_in: authResults.ExpiresIn,
              token_type: authResults.TokenType
            };
            auth.createCognitoSession(data);
          } else {
            // Failed auto signin navigate back to login page
            navigate('/login');
          }
        });
      }
    });
  }

  return (
    <AuthLayout>
      <Box maxWidth={'sm'}>
        <Box padding={theme.spacing(8)}>
          <Typography variant="h5" component="h2" align="center" mb={8} fontWeight="600">Activate Your Account</Typography>
          <Typography mb={4} align="center" color={theme.palette.grey['800']}>Please enter the verification code we emailed you:</Typography>
          <form onSubmit={handleSubmit}>
            <Grid container gap={8}>
              <Grid item xs={12}>
                <TextField name='verificationCode' label='Verification Code' fullWidth />
              </Grid>
              {error && 
                <Grid item xs={12}>
                  <Typography color="error">{error}</Typography>
                </Grid>
              }
              <Grid item xs={12}>
                <Button type="submit" variant="contained" size="large" fullWidth>Activate Account</Button> 
              </Grid>
            </Grid>
          </form>

          <Grid container mt={4} color={theme.palette.grey['600']}>
            <Grid item xs={12} textAlign="center">
              <Typography variant="body2" mt={2}>Already activated? <Link to="/login">Log in</Link></Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </AuthLayout>
  );
}

export default ActivateAccount;